import * as React from 'react';
import { useState } from 'react';

import { Button } from '@rmwc/button';
import '@rmwc/button/styles';

import { Dialog, DialogActions, DialogButton, DialogContent, DialogTitle } from '@rmwc/dialog';
import '@rmwc/dialog/styles';

import { useKeycloak } from '@react-keycloak/web';

import saveAs = require('file-saver');
import { pack } from 'msgpackr';

import { resetSiteKey } from '../api';
import { SiteData } from '../types';
import { sanitizeFileNamePart } from '../util';

interface ResetKeyDialogProps {
  site: SiteData;
  onClosed: () => void;
};

export const ResetKeyDialog: React.SFC<ResetKeyDialogProps> = ({ site, onClosed }) => {
  const { keycloak } = useKeycloak();

  const resetKey = async () => {
    try {
      const result = await resetSiteKey(site.id, keycloak.token!);
      onClosed();

      const host = `${location.protocol}//${location.host}`;
      const raw = pack([host, site.id, result]);

      const encoded = raw.map((i) => i + 128);

      const blob = new Blob([encoded], {type: 'application/octet-stream'});
      saveAs(blob, `${sanitizeFileNamePart(site.name)}.key`);
      onClosed();
    } catch(err: any) {
      alert("Unable to reset: " + err.message);
    }
  };

  return (
    <Dialog open={true} onClosed={onClosed}>
      <DialogTitle>Reset Q.reader Synchronization</DialogTitle>
      <DialogContent>
        <p>
          You will receive a synchronization configuration file that can be uploaded to the Q.reader to synchronize it with this commissioning portal.
        </p>
        <p>
          Resetting will disable the synchronization with devices that are already configured.
        </p>
      </DialogContent>
      <DialogActions>
        <DialogButton action="cancel" onClick={onClosed}>Cancel</DialogButton>
        <DialogButton isDefaultAction onClick={resetKey}>Reset</DialogButton>
      </DialogActions>
    </Dialog>
  );
};

export interface ResetKeyButtonProps {
  site: SiteData | undefined;
};

export const ResetKeyButton: React.SFC<ResetKeyButtonProps> = ({ site }) => {
  const [isVisible, setIsVisible] = useState(false);

  let dialog;

  if(site != null && isVisible) {
    dialog = (
      <ResetKeyDialog site={site} onClosed={() => setIsVisible(false)} />
    );
  }

  return <>
    {dialog}
    <Button className="margin_top" disabled={site == null} raised onClick={() => setIsVisible(true)}>
      Reset Sync
    </Button>
  </>;
};
